import { useAssetsWithBalance } from "../../../hooks/useAssetsWithBalance";
import { useOrderContext } from "../context";

export const useGivenBalance = () => {
  const {
    state: {
      assets: { given },
    },
  } = useOrderContext();
  const { assetsWithBalance } = useAssetsWithBalance();
  return assetsWithBalance.find(({ metadata }) => metadata.assetId === given?.metadata?.assetId)
    ?.quantity;
};
